import React, { FC, useEffect, useState } from 'react';

import { ABTest, ABTestBranch, Box, SiteNavbarOptionalProps, Variation } from '@lucid/components-react';
import { LucidTheme } from '@lucid/theme';

import Navbar, { NavbarOptionalProps, NavbarProps } from 'components/navbar/navbar';
import ABNavbar from './ab-navbar';

interface ABTestSimplifyMenuOnLPsProps extends NavbarProps{
  navbarProps?: SiteNavbarOptionalProps & NavbarOptionalProps;
  abTestTemplateSectionLink: string | null | undefined;
}

const ABTestSimplifyMenuOnLPs: FC<ABTestSimplifyMenuOnLPsProps> = ({
  pageType,
  i18nData,
  langPrefix,
  logo,
  navbarProps,
  nid,
  abTestTemplateSectionLink,
}) => {
  const [isABTest, setIsABTest] = useState(true);
  const [isTestLoaded, setIsTestLoaded] = useState(false);

  useEffect (() => {
    if ( window.innerWidth > 1024 ) {
      // Check query params for a non-branded campaign
      const searchParams = location.search.split('&');
      if (searchParams) {
        const utmCampaignIndex = searchParams
          .findIndex((queryIndex: string) => queryIndex.split('=')[0] === 'utm_campaign');
        if (utmCampaignIndex !== -1) {
          setIsABTest(!searchParams[utmCampaignIndex]
            .split('_').includes('brand'));
        }
      }
    } else {
      setIsABTest(false);
    }
    setIsTestLoaded(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isTestLoaded && (
        <Box
          css={(theme: LucidTheme) => ({
            position: 'sticky',
            top: '0',
            zIndex: theme.zIndices[10] })}
        >
          <ABTest
            isAboveTheFold
            hasConditionalTrigger={isABTest}
            test="Y21Q2_SimplifyMenuOnHighFunnelLPs"
          >
            <ABTestBranch branch={Variation.A}>
              <Navbar
                {...navbarProps}
                hasShadow
                isSticky
                i18nData={i18nData}
                langPrefix={langPrefix}
                logo={logo}
                nid={nid}
                pageType={pageType}
              />
            </ABTestBranch>
            <ABTestBranch branch={Variation.B}>
              <ABNavbar
                {...navbarProps}
                hasShadow
                isSticky
                isVariationB
                abTestTemplateSectionLink={abTestTemplateSectionLink}
                i18nData={i18nData}
                langPrefix={langPrefix}
                logo={logo}
                nid={nid}
                pageType={pageType}
              />
            </ABTestBranch>
            <ABTestBranch branch={Variation.C}>
              <ABNavbar
                {...navbarProps}
                hasShadow
                isSticky
                isVariationC
                abTestTemplateSectionLink={abTestTemplateSectionLink}
                i18nData={i18nData}
                langPrefix={langPrefix}
                logo={logo}
                nid={nid}
                pageType={pageType}
              />
            </ABTestBranch>
            <ABTestBranch branch={Variation.D}>
              <ABNavbar
                {...navbarProps}
                hasShadow
                isSticky
                isVariationD
                abTestTemplateSectionLink={abTestTemplateSectionLink}
                i18nData={i18nData}
                langPrefix={langPrefix}
                logo={logo}
                nid={nid}
                pageType={pageType}
              />
            </ABTestBranch>
          </ABTest>
        </Box>
      )}
    </>
  );
};

export default ABTestSimplifyMenuOnLPs;
